"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var geolocation_1 = require("../constants/geolocation");
var useCurrentLocationPosition = function () {
    var _a = react_1.useState(null), currentPosition = _a[0], setCurrentPosition = _a[1];
    var _b = react_1.useState(null), error = _b[0], setError = _b[1];
    var saveCurrentPosition = function (_a) {
        var coords = _a.coords;
        setCurrentPosition({
            latitude: coords.latitude,
            longitude: coords.longitude,
        });
    };
    var onError = function (error) {
        setError(error.message);
    };
    react_1.useEffect(function () {
        var geolocation = navigator.geolocation;
        if (!geolocation) {
            setError(geolocation_1.GEOLOCATION.NOT_SUPPORTED);
            return;
        }
        var watcher = geolocation.watchPosition(saveCurrentPosition, onError);
        return function () { return geolocation.clearWatch(watcher); };
    }, []);
    return { currentPosition: currentPosition, error: error };
};
exports.default = useCurrentLocationPosition;
